import React from "react";
import { STOCK_BADGES } from "../constants/catalog";

export default function StockBadge({ status, testId }) {
    const b = STOCK_BADGES[status] || STOCK_BADGES.in_stock;
    return (
        <span
            data-testid={testId}
            className={`inline-block text-[9px] tracking-[0.2em] uppercase px-2 py-1 border ${b.cls}`}
        >
            {b.label}
        </span>
    );
}
